import { useEffect } from 'react';

import { useStopEventInvitesState, useStopEventInvitesActions } from './StopEventInvitesContext';

import { stopEventInvites } from './restApi';

const StopEventInvitesLoader = ({ id }) => {
  const state = useStopEventInvitesState();
  const { initializeState, onResponse, onError } = useStopEventInvitesActions();

  useEffect(() => {
    initializeState();
  }, []);

  useEffect(() => {
    if (state?.stopEventInvites?.inviteEmail && state?.stopEventInvites?.inviteCode) {
      stopEventInvites({
        onResponse,
        onError,
        body: {
          event_id: id,
          invite_email: state?.stopEventInvites?.inviteEmail || '',
          invite_code: state?.stopEventInvites?.inviteCode || '',
          authenticity_token: document.querySelector("meta[name='csrf-token']")?.getAttribute("content")
        },
      });
    }
  }, [state?.stopEventInvites?.inviteEmail, state?.stopEventInvites?.inviteCode]);

  return null;
};

export default StopEventInvitesLoader;
